import React from 'react';
import {usePanorama} from '@wix/yoshi-flow-editor';
import {FormViewer} from '@wix/form-viewer/widget';
import {Accordion, AccordionTheme, Divider} from 'wix-ui-tpa/cssVars';
import {FormModel} from '../../../../../../domain/models/checkout/Cart/Form.model';
import {classes} from './AdditionalDetailsStepOpen.st.css';
import {useICUI18n} from '../../../../Hooks/useICUI18n';
import {AdditionalDetailsFormSubtitle} from './AdditionalDetailsFormSubtitle';

export enum AdditionalDetailsFormDataHook {
  formItem = 'AdditionalDetailsForm.formItem',
  formItemAccordion = 'AdditionalDetailsForm.formItemAccordion',
  formItemContent = 'AdditionalDetailsForm.formItemContent',
}

export const AdditionalDetailsForm: React.FC<{form: FormModel}> = ({form}) => {
  const {id, formId, title, description} = form;
  const i18n = useICUI18n();
  const panorama = usePanorama();

  return (
    <li className={classes.eventItem} data-hook={AdditionalDetailsFormDataHook.formItem}>
      <Accordion
        data-hook={AdditionalDetailsFormDataHook.formItemAccordion}
        theme={AccordionTheme.Box}
        initiallyExpanded={[id]}>
        <Accordion.Item
          id={id}
          key={id}
          title={title}
          subtitle={(<AdditionalDetailsFormSubtitle description={description} />) as unknown as any}>
          <div className={classes.formItemContent} data-hook={AdditionalDetailsFormDataHook.formItemContent}>
            <Divider className={classes.divider} />
            <FormViewer
              i18n={i18n}
              panorama={panorama}
              formId={formId}
              values={{}}
              errors={[]}
              onChange={() => {}}
              onValidate={
                // istanbul ignore next
                () => {}
              }
            />
          </div>
        </Accordion.Item>
      </Accordion>
    </li>
  );
};
